import React, { Component } from 'react';
import CriteriaBox from './Components/CriteriaBox';
import Config from './Configs/criteria.json'
import './Tooltip.css'

export default class CriteriaTableAdvanced extends Component {
    // constructor(props) {
        // super(props);
        // this.handleSelectionBoxChange = this.handleSelectionBoxChange.bind(this);
    // }
    handleCriteriaBoxChange = (key, i) => (criteriavalues, cb) => {
        this.props.handleCriteriaBoxChange(key, i, criteriavalues, cb);
    }
    generateCriteriaTable = () => {
        let row = [];
        for (let i=0; i<Config.criteria.advanced[this.props.section].length; i++) {
            let items = Config.criteria.advanced[this.props.section][i];
            row.push(<CriteriaBox token={this.props.token} fromPreset={this.props.fromPreset} items={items} key={Config.criteria.advanced[this.props.section][i].id} onChange={this.handleCriteriaBoxChange(this.props.section, i)} data={this.props.criteria.advanced[this.props.section][i]} config={items} section={this.props.section} />);
        }
        return row;
    }
    render() {
        return (
            <table className="CriteriaTable">
                <tbody>
                { this.generateCriteriaTable() }
                </tbody>
            </table>
        );
    }
}